@import (reference) '../../../../../constants/screen-width-breakpoints.module.less';
@import (reference) '../../../../../constants/spacing.module.less';

.return-details-grid {
  flex: 1;
  display: grid;

  &.three-columns {
    grid-template: 'address-column dates-column rma-column';
    grid-template-columns: minmax(224px, 312px) 1fr 1fr;
    grid-template-rows: auto;
  }

  &.two-columns {
    grid-template: 'address-column dates-column' 'address-column rma-column';
    grid-template-columns: minmax(192px, 390px) auto;
    grid-template-rows: auto auto;
    row-gap: @space-8;
  }

  &.one-column {
    grid-template:
      'address-column'
      'dates-column'
      'rma-column';
    grid-template-columns: auto;
    grid-template-rows: auto auto auto;
    row-gap: @space-16;
  }
}
